import {
  type SmsCampaignAttemptDto as ApiSmsCampaignAttemptDto,
  type CampaignDto,
  CampaignDtoStatusEnum,
  type ListItemDto,
  type OrganizationSmsProviderConfigurationIntegrationEnum,
  type SmsCampaignAttemptDtoStatusEnum,
  type SmsCampaignV2ProviderReportDto,
  type UserLinkDto,
} from '@workers-benefit-fund/api'

import type { SmsProviderIntegrationEnum } from '@v2/domains/smsCampaigns/smsCampaigns.type'

export type SmsCampaignDto = Omit<
  CampaignDto,
  'status' | 'targetsList' | 'createdBy' | 'updatedBy' | 'smsCampaign'
> & {
  status: CampaignDtoStatusEnum
  targetsList?: SmsCampaignTargetsList
  createdBy: UserLinkDto | null
  updatedBy?: UserLinkDto | null
  smsCampaign?: Omit<
    NonNullable<CampaignDto['smsCampaign']>,
    'provider' | 'campaignAttempts'
  > & {
    provider?: SmsCampaignProvider
    campaignAttempts?: SmsCampaignAttemptDto[] | null
  }
}

export type SmsCampaignAttemptDto = Omit<
  ApiSmsCampaignAttemptDto,
  'provider' | 'status' | 'failureReason'
> & {
  provider: SmsCampaignProvider
  status: `${SmsCampaignAttemptDtoStatusEnum}`
  failureReason?: string | null
}

export type SmsCampaignTargetDto = ListItemDto & {
  delivered?: boolean | null
  errorMessage?: string | null
  retries?: number | null
  retryable?: boolean | null
}

export interface SmsCampaignTargetsList {
  records?: SmsCampaignTargetDto[]
  totalRecords?: number
  recordsLeft?: number
}

export type SmsCampaignTargetBooleanFilter = 'true' | 'false' | null

export interface SmsCampaignTargetFilters {
  delivered: SmsCampaignTargetBooleanFilter
  retryable: SmsCampaignTargetBooleanFilter
}

export interface SmsCampaignDetailQueryParams {
  campaignId: string
  errorCode?: string
  delivered?: boolean
  retryable?: boolean
  retries?: number
  limit?: number
  offset?: number
}

export { CampaignDtoStatusEnum }

export type SmsCampaignProvider =
  `${OrganizationSmsProviderConfigurationIntegrationEnum}`

export const SMS_PROVIDER_LABELS: Record<SmsCampaignProvider, string> = {
  BANDWIDTH: 'Bandwidth',
  TWILIO: 'Twilio',
}

export interface SmsCampaignFilters {
  name?: string
  provider: SmsCampaignProvider | null
  status?: CampaignDtoStatusEnum[]
  fromSendDate?: string
  toSendDate?: string
}

export type RequestSmsCampaignProviderReportArgs = {
  provider: SmsProviderIntegrationEnum
} & SmsCampaignV2ProviderReportDto

export interface RequestSmsCampaignReportArgs {
  campaignId: string
}

export const TAGS_SMS_CAMPAIGNS = {
  SmsCampaigns: 'SmsCampaigns',
  SmsCampaignById: 'SmsCampaignById',
} as const

export const SMS_CAMPAIGN_UPDATE_POLICY = 'is_update_sms_campaign_enabled'
